export default __webpack_public_path__ + "static/media/clock.c33dae0c.png";